// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import {GlobalState} from 'types/store';

export function isShowOnboardingTaskCompletion(state: GlobalState) {
    // TIME-505 Disable onboarding tours
    return false;
    return state.views.onboardingTasks.isShowOnboardingTaskCompletion;
}

export function isShowOnboardingCompleteProfileTour(state: GlobalState) {
    // TIME-505 Disable onboarding tours
    return false;
    return state.views.onboardingTasks.isShowOnboardingCompleteProfileTour;
}

export function isShowOnboardingVisitConsoleTour(state: GlobalState) {
    // TIME-505 Disable onboarding tours
    return false;
    return state.views.onboardingTasks.isShowOnboardingVisitConsoleTour;
}
